<template>  
  <div
    class="w-full flex flex-col  relative"
    :class="{'gap-3': isMobileOpen}"
  >
    <div class="block lg:hidden w-full">
      <button
        class="relative btn btn-red w-full flex flex-row justify-center items-center"
        @click="isMobileOpen = !isMobileOpen"
      >
        Kereső
        <img
          src="/img/icons/inputs/dropdown_arrow_icon.svg"
          class="h-[16px] w-[16px] absolute right-4 top-4 transform transition-all group-hover:text-gray-darkest duration-500 "
          :class="{ 
            'rotate-180': isMobileOpen,
          }"
        >
      </button>
    </div>

    <div 
      :class="{ 'max-h-[2000px] opacity-100': isMobileOpen}"
      class="w-full flex flex-col lg:flex-row gap-3 max-h-0 lg:max-h-full transition-all duration-500 opacity-0 lg:opacity-100"
    >
      <ReDateRange
        v-model="form.selectedDays"
        class="w-full lg:w-4/12"
        :has-errors="false"
        icon="/img/calendar_icon.svg"
      />
      <ReInput
        id="searchtext"
        v-model="form.text"
        placeholder="Keresendő szöveg"
        type="text"
        :has-errors="false"
        icon="/img/pen_icon.svg"
        class="w-full lg:w-3/12"
      />
      <ReSelect
        v-model="form.themes"
        :items="themes"
        placeholder="Témakör"
        multiple
        :has-errors="false"
        class="w-full lg:w-4/12"
      />
      <div class="w-full lg:w-1/12">
        <button
          type="button"
          class="btn btn-red w-full"
          @click.prevent="submit"
        >
          <i class="fas fa-search" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ReInput from "~/components/rxt/reform/ReInput.vue";
import ReSelect from "~/components/rxt/reform/ReSelect.vue";
import ReDateRange from "~/components/rxt/reform/ReDateRange";

export default {
  components: {
    ReInput,
    ReSelect,
    ReDateRange
  },
  props: {
    queryObject: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isMobileOpen: false,
      showNav: false,
      form: {
        themes: [],
        text: "",
        selectedDays: {
          from: null,
          to: null
        }
      }
    };
  },
  computed: {
    years() {
      const years = [];

      for (let i = this.$moment().year(); i >= 1996; i--) {
        years.push(i);
      }

      return years.map(year => {
        return {
          key: this.$unique(),
          value: year,
          text: year
        };
      });
    },
    themes() {
      return this.$store.state.gleanerTypes.map(item => {
        return {
          key: item.type,
          value: item.type,
          text: item.type
        };
      });
    }
  },
  watch: {
    queryObject(newData) {
      this.makeFormObjectFromQueryObject(newData);
    }
  },
  async fetch() {
    this.makeFormObjectFromQueryObject(this.queryObject);
    await this.$store.dispatch("loadGleanerTypes");
  },
  methods: {
    submit() {
      const queryObject = {};

      queryObject.limit = this.queryObject.limit ? this.queryObject.limit : 25;

      if (this.form.text) {
        queryObject["filter[search]"] = this.form.text;
      }
      if (this.form.selectedDays.from && this.form.selectedDays.to) {
        queryObject["filter[between]"] =
          this.form.selectedDays.from + ":" + this.form.selectedDays.to;
      }

      if (this.themes.length > 0) {
        queryObject["filter[theme]"] = this.form.themes.join(",");
      }

      this.$emit("searchChanged", queryObject);
      this.showNav = false;
    },

    makeFormObjectFromQueryObject(newData) {
      const form = {
        themes: [],
        text: "",
        selectedDays: {
          from: null,
          to: null
        }
      };

      // set form params for eventsearch component
      if (newData["filter[search]"]) {
        form.text = newData["filter[search]"];
      }
      if (newData["filter[between]"]) {
        const split = newData["filter[between]"].split(":");
        form.selectedDays.from = split[0];
        form.selectedDays.to = split[1];
      }
      if (newData["filter[theme]"]) {
        form.themes = newData["filter[theme]"].split(",");
      }

      this.form = form;
    },
    calculateOffset() {
      return this.modules.length * 5;
    }
  }
};
</script>
